import React, { useEffect, useState } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import api from '../_utility/AxiosConfig';
import { Helmet } from 'react-helmet';
import HtmlParser from 'html-react-parser';

const BlogDetails = () => {
    const { slug } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [post, setPost] = useState([]);
    const [previousPostSlug, setPreviousPostSlug] = useState('');
    const [nextPostSlug, setNextPostSlug] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    useEffect(() => {
        setLoading(true);
        api.post(`/api/post/details/${slug}`)
            .then(res => {
                const data = res.data.data;
                setPost(data);
                setPreviousPostSlug(res.data.previous_post_slug);
                setNextPostSlug(res.data.next_post_slug);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching posts:", error);
            });
    }, [slug]);

    return (
        <>
        <Helmet>
                <title>{post.title || 'Blog Post'}</title>
                <meta name="description" content={post.meta_description || ''} />
                <meta name="keywords" content={post.meta_keywords || ''} />
                {/* Open Graph / Facebook */}
                <meta property="og:type" content="article" />
                <meta property="og:title" content={post.meta_title || 'Blog Post'} />
                <meta property="og:description" content={post.meta_description || ''} />
                {post.image && <meta property="og:image" content={post.image} />}
                
                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={post.meta_title || 'Blog Post'} />
                <meta name="twitter:description" content={post.meta_description || ''} />
                {post.thumbnail && post.thumbnail.length > 0 ? (
                    <meta name="twitter:image" content={post.thumbnail[0]?.data_url} />
                ) : null}
            </Helmet>
            <section>
                <div className="inn-body-section">
                    <div className="container">
                        <section className="content-section">
                            {post && post.title && !loading ? (
                                <>
                                    {post.thumbnail && post.thumbnail.length > 0 ? (
                                        <img
                                            src={post?.thumbnail[0]?.data_url}
                                            alt={post?.title}
                                            className="img-fluid"
                                            style={{ 'maxWidth': '100%', 'marginBottom': '20px' }}
                                        />
                                    ) : (<></>)}
                                    <div className='blogPostDetails'>
                                        <Link to={`/post/details/${post.slug}`} className="post-title">{post.title}</Link>
                                        <ul className="atributes">
                                            <li><i className="fa fa-user-secret"></i><span style={{ 'color':'#000' }}>Author:</span><span>{post.created_by.name.replace('Super', '')}</span></li>
                                            <li><i className="fa fa-calendar"></i><span style={{ 'color':'#000' }}>Created At:</span><span>{post.created_at}</span></li>
                                            <li><i className="fa fa-briefcase"></i><span style={{ 'color':'#000' }}>Category:</span><span>{post.category.name}</span></li>
                                            <li className="tags"><i className="fa fa-tags"></i><span>Tags:</span>
                                                {Object.values(post.tags).map((name, index, arr) => (
                                                    <span key={index}>
                                                        {name}{index < arr.length - 1 ? ', ' : ''}
                                                    </span>
                                                ))}
                                            </li>
                                        </ul>
                                    </div>

                                    <article className='post-content'>
                                        {HtmlParser(post.content)}
                                    </article>

                                    <div className='form-group mt-5'>
                                        {previousPostSlug ? (
                                            <Link to={`/post/details/${previousPostSlug}`} className="btn btn-info pull-left">
                                            Previous Post
                                            </Link>
                                        ) : (
                                            <></>
                                        )}

                                        {nextPostSlug ? (
                                            <Link to={`/post/details/${nextPostSlug}`} className="btn btn-info pull-right">
                                            Next Post
                                            </Link>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="col-md-12">
                                        <div className="ph-item border-0 p-0">
                                            <div className="ph-col-12">
                                                <div className="ph-picture"></div>
                                                <div className="ph-row">
                                                    <div className="ph-col-10 big"></div>
                                                    <div className="ph-col-2 empty big"></div>
                                                    <div className="ph-col-4"></div>
                                                    <div className="ph-col-8 empty"></div>
                                                    <div className="ph-col-6"></div>
                                                    <div className="ph-col-6 empty"></div>
                                                    <div className="ph-col-12"></div>
                                                </div>
                                            </div>

                                            <div className="ph-col-4">
                                                <div className="ph-picture"></div>
                                            </div>

                                            <div>
                                                <div className="ph-row">
                                                    <div className="ph-col-6"></div>
                                                    <div className="ph-col-6 empty"></div>
                                                    <div className="ph-col-2"></div>
                                                    <div className="ph-col-10 empty"></div>
                                                    <div className="ph-col-8"></div>
                                                    <div className="ph-col-4 empty"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                </div>
                                            </div>
                                            <div className="ph-col-12">
                                                <div className="ph-row">
                                                    <div className="ph-col-10 big"></div>
                                                    <div className="ph-col-2 empty big"></div>
                                                    <div className="ph-col-4"></div>
                                                    <div className="ph-col-8 empty"></div>
                                                    <div className="ph-col-6"></div>
                                                    <div className="ph-col-6 empty"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-10 big"></div>
                                                    <div className="ph-col-2 empty big"></div>
                                                    <div className="ph-col-4"></div>
                                                    <div className="ph-col-8 empty"></div>
                                                    <div className="ph-col-6"></div>
                                                    <div className="ph-col-6 empty"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-10 big"></div>
                                                    <div className="ph-col-2 empty big"></div>
                                                    <div className="ph-col-4"></div>
                                                    <div className="ph-col-8 empty"></div>
                                                    <div className="ph-col-6"></div>
                                                    <div className="ph-col-6 empty"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ph-item border-0 p-0">
                                            <div className="ph-col-12">
                                                <div className="ph-row">
                                                    <div className="ph-col-6 big"></div>
                                                    <div className="ph-col-6 empty"></div>
                                                    <div className="ph-col-12"></div>
                                                    <div className="ph-col-12"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </section>
                    </div>
                </div>
            </section>
        </>
    );
}

export default BlogDetails;